import React, {useState, useEffect} from 'react';
import {Container, Row, Col} from 'reactstrap';
import {FormGroup, Label, Input} from 'reactstrap';

import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/App.css';

import uuidv4 from "uuid/v4";


const TopicSelector = (props) => {
    return (
        <FormGroup>
            <Label for="topicSelect" className="label-selector">Argomento</Label>
            <Input type="select" name="select" id="topicSelect" defaultValue='-' onChange={props.select_topic}>
                <option value='-'> - </option>
                {props.argument_list.map((item, i) => (<option key={i.toString()} value={item}> {item} </option>))}
            </Input>
        </FormGroup>
    );
};


const ArticleSelector = (props) => {
    return (
        <FormGroup>
            <Label for="articleSelect" className="label-selector">Articolo</Label>
            <Input type="select" name="select" id="articleSelect" defaultValue='-' onChange={props.select_article}>
                <option value='-'> - </option>
                {props.article_list.map((item, i) => (<option key={i.toString()} value={item}> {item} </option>))}
            </Input>
        </FormGroup>
    );
};


const Article = (props) => {
    return (props.article === null) ? null : (
        <div>
            <h1 className="article-title my-5">{props.article.title}</h1>
            <h2 className="article-subtitle my-5">{props.article.subtitle}</h2>
            {
                props.article.content_list.map((x) => {

                    if (x.tag === "bibliography") {
                        return (
                            <div key={uuidv4()} style={{ textAlign: 'justify', textJustify: 'inter-word' }}>
                                <h3 className="article-h3"> Bibliografia </h3>
                                <ul>
                                    {x.innerHTML.map((y) => <li key={uuidv4()}> {y} </li>)}
                                </ul>
                            </div>
                        );

                    }

                    if (x.tag === "ul") {
                        return (
                            <ul key={uuidv4()} style={{ textAlign: 'justify', textJustify: 'inter-word' }}>
                                {x.innerHTML.map((y) => <li key={uuidv4()} dangerouslySetInnerHTML={{ __html: y }} ></li>)}
                            </ul>
                        );
                    }

                    if (x.tag === "h3") {
                        return <h3 key={uuidv4()} className="article-h3" style={{ textAlign: 'justify', textJustify: 'inter-word' }}> {x.innerHTML} </h3>;
                    }

                    if (x.tag === "p") {
                        return <p key={uuidv4()} style={{ textAlign: 'justify', textJustify: 'inter-word' }} dangerouslySetInnerHTML={{ __html: x.innerHTML }}></p>;
                    }

                    if (x.tag === "table") {
                        return (
                            <table key={uuidv4()} className='article-table' style={{ 'marginRight': 'auto', 'marginLeft': 'auto' }}>
                                <thead>
                                    <tr>
                                        {x.innerHTML[0].map((e) => {
                                            return <th key={uuidv4()} className='article-th'> {e.toString()} </th>;
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                    {x.innerHTML.slice(1).map((row) => {
                                        return <tr key={uuidv4()} className='article-tr'>
                                            {row.map((e) => {
                                                return <td key={uuidv4()} className='article-td'> {e.toString()} </td>;
                                            })}
                                        </tr>;
                                    })}
                                </tbody>
                            </table>
                        );
                    }

                    if (x.tag === "img") {
                        return (
                            <div style={{ marginTop: '20px', marginBottom: '20px' }}>
                                <img className="img-fluid" src={x.src} alt="immagine articolo" />
                                <br />
                                <span className="article-figure-caption" style={{ marginTop: '12px' }}> {x.caption} </span>
                            </div>
                        )
                    }

                    return null;
                })
            }
        </div>
    );
};


const Articles = () => {
    const [metadata, setMetadata] = useState([]);
    const [listTopic, setListTopic] = useState([]);
    const [listArticles, setListArticles] = useState([]);
    const [selectedTopic, setSelectedTopic] = useState("-");
    const [articleData, setArticleData] = useState(null);

    const setTopic = (event) => {
        setSelectedTopic(event.target.value);
        setArticleData(null);
        document.getElementById('articleSelect').value = '-';
    };
    
    const setArticle = (event) => {
        const article_file_metadata = metadata.filter((x) => ((x['argument'] === selectedTopic) && (x['title'] === event.target.value)));
        const article_file = (article_file_metadata.length > 0) ? article_file_metadata[0]["filename"] : undefined;
        if (article_file !== undefined) {
            fetch(`/api/${article_file}`)
                .then(res => res.json())
                .then(data => setArticleData(data))
                .catch(err => setArticleData(null));
        }
        else {
            setArticleData(null);
        }
    }

    useEffect(() => {
        fetch('/api/article_metadata.json')
            .then(res => res.json())
            .then(data => setMetadata(data))
            .catch((err) => console.log(err));
    }, []);

    useEffect(() => {
        setListTopic([...new Set(metadata.map((x) => x['argument']))]);
    }, [metadata]);


    useEffect(() => {
        setListArticles([...new Set(metadata.filter((x) => x['argument'] === selectedTopic).map((x) => x['title']))])
    }, [selectedTopic, metadata]);

    return (
        <section id='articles' className='elem-content-container' style={{paddingTop: '75px'}}>
                <div className='bg-primary' style={{paddingTop: '53px', paddingBottom: '48px'}}>
                    <Container>
                        <Row>
                            <Col lg="10" className="mx-auto text-center">
                                <h2 className="section-heading text-white mb-5">Approfondimenti</h2>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg='6' className="mx-auto text-center">
                                <TopicSelector argument_list={listTopic} select_topic={setTopic} />
                            </Col>
                            <Col lg='6' className="mx-auto text-center">
                                <ArticleSelector article_list={listArticles} select_article={setArticle} />
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Container>
                    <Article article={articleData} />
                </Container>
            </section>
    );
};


export default Articles;
